export default {"src":"/_next/static/media/favicon.43c99849.ico","height":32,"width":32};